exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hr {\n    width: 100%;\n    height: 1px;\n    background-color: #999;\n    margin: 50px 0;\n}\n\n.hr .text {\n    width: 309px;\n    height: 21px;\n    font-size: 14px;\n    color: #232323;\n    text-decoration: none solid rgb(35, 35, 35);\n    padding: 0 12px;\n    position: relative;\n    top: -10px;\n    background: #fff;\n}\n", ""]);

// exports
